var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccelerometerSensor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2583_12118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0688 28.6849L42.3041 37.0272L33.9618 39.2624L32.9611 35.5274L34.9269 35.0006L22 27.5372L9.07305 35.0006L11.0389 35.5274L10.038 39.2624L1.69586 37.0272L3.93117 28.6849L7.66617 29.6857L7.13947 31.6516L20.0664 24.1882V9.2614L18.6273 10.7005L15.893 7.96633L22 1.85938L28.1069 7.96633L25.3727 10.7005L23.9336 9.2614V24.1882L36.8605 31.6516L36.3338 29.6857L40.0688 28.6849Z",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4391 28.9484C11.0345 27.7761 10.8281 26.5447 10.8281 25.3046C10.8281 19.9539 14.6219 15.3544 19.875 14.3368",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4361 32.6286C29.6231 33.565 28.6598 34.3595 27.5859 34.9796C22.9521 37.655 17.0719 36.6692 13.564 32.6288",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1248 14.3367C25.3422 14.5726 26.5119 15.0095 27.5859 15.6295C32.2197 18.3049 34.306 23.8901 32.5609 28.9482",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 36.9061V43.2813",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6504 41.4902L22 44.1406L19.3496 41.4902",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0471 19.5038L37.5682 16.3162",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.692 14.9164L38.3125 15.8866L37.3423 19.507",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9527 19.5038L6.4317 16.3162",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65756 19.507L5.6875 15.8866L9.30795 14.9164",
    stroke: "black",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2583_12118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5,
    height: 44.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerometerSensor);
export default __webpack_public_path__ + "static/media/accelerometer-sensor.f2dd74022b955f63c176dd87d5dcabd5.svg";
export { ForwardRef as ReactComponent };